import React from 'react';
import './App.css';
import Section, { SectionColor } from './Components/Section';
import CaseStudies from './Sections/CaseStudies';
// Hidden — AI stories are not live yet. Restore these two imports and the
// <AIProjects /> line below to bring the section back.
// import AIProjects from './Sections/AIProjects';

import caseStudyData from './data/caseStudies';
// import aiProjectData, { aiProjectsIntro } from './data/aiProjects';
import clientData from './data/clients';
import contactData from './data/contact';
import Svgs from './Svgs';

const App: React.FC = () => {
  return (
    <div role="main">
      <section className="header">
        <a href="#top" className="jw-link logo">
          <Svgs.signature />
        </a>
        <a href="#contact" className="jw-link contact-link">
          <Svgs.envelope />
        </a>
      </section>
      <div id="top"></div>
      <Section
        id='hero'
        isFixed={true}
      >
        <div className="inner">
          <div className="grid align-center justify-center">
            <div className="col-12 hero-text">
              <h1 className="headline">
                hi there! i'm JOE WANKO, a web developer based in new&nbsp;york
              </h1>
            </div>
          </div>
        </div>
      </Section>
      <Section
        color={SectionColor.GREY}
        id='about'
        isFixed={true}
      >
        <div className="col-12 hero-text">
          <h2 className="section-copy">
            i'm currently working with the websites&nbsp;collection&nbsp;team
            at&nbsp;<a href="https://squarespace.com">Squarespace</a>.
          </h2>
        </div>
      </Section>
      <CaseStudies caseStudies={caseStudyData} color={SectionColor.WHITE} />
      {/* <AIProjects intro={aiProjectsIntro} projects={aiProjectData} color={SectionColor.GREY} /> */}
      <Section
        color={SectionColor.WHITE}
        id='clients-and-partners'
        header='clients & partners'
      >
        <ul className='client-list'>
          {...clientData.map((client) => {
            if (Svgs.hasOwnProperty(client.key)) {
              const SvgComponent = Svgs[client.key];

              return (
                <li key={client.key}>
                  <SvgComponent aria-label={client.name} />
                </li>
              );
            }
          })}
        </ul>
      </Section>
      <Section
        color={SectionColor.GREY}
        id='resume'
      >
        <div
          className="center">
          <a href="/public/pdf/JoeWanko_Resume.pdf" className="link link--resume" target="_blank">view my resume (PDF)</a>
        </div>
      </Section>
      <Section
        id="contact"
        header="let's be in touch"
      >
        {contactData.map((contactLink) => {
          return (
            <div key={contactLink.name} className="contact--link-wrapper col-12 j-text-center">
              <div className="contact--link">
                <span className="link--label" id="cl-email">{contactLink.name}</span>
                <a className="link" aria-labelledby="cl-email" href={contactLink.url} target={contactLink.target}>{contactLink.linkText}</a>
              </div>
            </div>)
        })}
        <div className="contact--signature" aria-hidden="true">
          <Svgs.signatureNoBorder />
        </div>
      </Section>
      <section className="extras">
        <div className="extra-box header-extra"></div>
        <div className="extra-bg"></div>
        <div className="extra-box footer-extra"></div>
      </section>
    </div>
  );
}

export default App;
